import { queryAll } from '../lib/query';
import gtmDataLayerPush from '../lib/gtmDataLayerPush';

export default function gtmInit() {
	const gtmElements = queryAll('[data-gtm-event]');

	gtmElements.forEach((element) => {
		const gtmEvent = element.getAttribute('data-gtm-event');

		const eventNames = [
			'funnel_start',
			'funnel_step',
			'funnel_finish',
			'funnel_error',
			'funnel_click',
			'funnel_login',
			'start_game',
			'deposit',
			'otd',
			'spend_virtual_currency',
			'earn_virtual_currency',
			'game_error',
			'payment_start',
			'payment_step',
			'payment_finish',
			'payment_error',
			'payment_click',
			'app_download_click',
			'cta_click',
		];

		if (!eventNames.includes(gtmEvent)) {
			return;
		}

		const eventParameters = [
			'app_type',
			'click_text',
			'client_type',
			'component',
			'context',
			'currency',
			'deposit_num',
			'error_code',
			'error_message',
			'error_text',
			'error_type',
			'game_id',
			'game_name',
			'identification_type',
			'is_sign_up',
			'item_id',
			'item_name',
			'mft_id',
			'mft_name',
			'player_id',
			'pre_reg_user_id',
			'process_name',
			'step_name',
			'step_number',
			'title',
			'transaction_id',
			'value',
			'version_number',
			'virtual_currency_name',
		];

		/**
		 * @type {string}
		 */
		const elementText = (() => {
			/**
			 * @type {string | undefined}
			 */
			let text = element.innerText?.trim();
			if (!text) {
				const img = element.querySelector('img');
				if (img instanceof HTMLImageElement) {
					text = img.alt?.trim();
				}
			}
			return text?.length > 0 ? text.toLowerCase() : 'N/A';
		})();

		/**
		 * @type {Map<string, string>}
		 */
		const dataSet = new Map();

		eventParameters.forEach((parameter) => {
			const value = element.getAttribute(`data-gtm-${parameter}`)?.trim();
			if (value?.length > 0) {
				dataSet.set(parameter, value.toLowerCase());
			}
		});

		/**
		 * @param {string} parameter
		 * @param {string|undefined} fallback
		 * @returns {string}
		 */
		const getEventDataValue = (parameter, fallback = 'N/A') =>
			dataSet.has(parameter) ? dataSet.get(parameter) : fallback;

		/**
		 * @type {Map<string, Record<string, string|number>>}
		 */
		const eventSet = new Map();

		/**
		 * @param {Record<string, string|number>} eventData
		 * @returns {Record<string, string|number>}
		 */
		const prepareEventData = (eventData) => {
			if (
				!['app_download_click', 'cta_click', 'funnel_start'].includes(gtmEvent)
			) {
				return eventData;
			}

			eventData.environment = isHofProd ? 'prod' : 'stage';
			eventData.ts_micros = Date.now();

			return eventData;
		};

		const documentTitle = document.title?.trim().toLowerCase();

		// @TODO: Add more events

		eventSet.set('cta_click', {
			click_text: getEventDataValue('click_text', elementText),
			title: getEventDataValue('title', elementText),
			context: getEventDataValue('context', documentTitle),
			component: getEventDataValue('component'),
		});

		eventSet.set('app_download_click', {
			app_type: getEventDataValue('app_type'),
			click_text: getEventDataValue('click_text', elementText),
		});

		eventSet.set('funnel_start', {
			click_text: getEventDataValue('click_text', elementText),
			process_name: getEventDataValue('process_name', 'welcome'),
			step_number: getEventDataValue('step_number', '0'),
			identification_type: getEventDataValue('identification_type'),
		});

		if (!eventSet.has(gtmEvent)) {
			return;
		}

		element.addEventListener('click', (e) => {
			gtmDataLayerPush(gtmEvent, prepareEventData(eventSet.get(gtmEvent)));
		});
	});
}
